import { scrollToId } from "./scrollHelpers.js";

export default function initJumpLinks() {
  Array.from(document.querySelectorAll("a[href^='#'")).forEach((el, index) => {
    el.addEventListener("click", (e) => {
      try {
        // make sure this href is valid

        const hash = el.getAttribute("href");
        const targetEl = document.querySelector(hash);

        e.preventDefault();
        const isAccordion =
          targetEl.classList.contains("js-accordion-link") &&
          !targetEl.parentNode.classList.contains("is-open");

        isAccordion && targetEl.click();
        scrollToId(hash);
      } catch (e) {
        // probably a bad href
      }
    });
  });
}
